import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "image-header flex align-items-end justify-content-end p-3",
    style: _normalizeStyle(
      _ctx.image_url && {
        'background-image': `url(${_ctx.url})`
      }
    )
  }, [
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ], 4))
}